/**
 * Homepage motion layer.
 *
 * Adds `html.fx`, then enhances. It never gates content on itself: if this fails to
 * run, every element stays visible and static.
 */
export default function homeFx() {
    if (document.body.dataset.theme !== 'home') { return; }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

    var root = document.documentElement;
    var home = document.querySelector('.home');
    if (!home) { return; }

    root.classList.add('fx');

    function wrapWord(chunk, index) {
        var span = document.createElement('span');
        span.className = 'w';
        span.style.setProperty('--i', index);
        span.textContent = chunk;
        return span;
    }

    function splitTextNode(node, fragment, counter) {
        node.textContent.split(/(\s+)/).forEach(function (chunk) {
            if (!chunk) { return; }
            if (!chunk.trim()) {
                fragment.appendChild(document.createTextNode(chunk));
                return;
            }
            fragment.appendChild(wrapWord(chunk, counter.i++));
        });
    }

    function splitInto(node, fragment, counter) {
        if (node.nodeType === 3) {
            splitTextNode(node, fragment, counter);
            return;
        }
        if (node.nodeType !== 1) {
            fragment.appendChild(node.cloneNode(true));
            return;
        }
        // Audience spans stay in the heading; words inside them rise. Wrapping the
        // whole arm as one `.w` left an empty line when the other arm was active.
        if (node.hasAttribute('data-when')) {
            var arm = node.cloneNode(false);
            Array.prototype.slice.call(node.childNodes).forEach(function (child) {
                splitInto(child, arm, counter);
            });
            fragment.appendChild(arm);
            return;
        }
        var wrapper = document.createElement('span');
        wrapper.className = 'w';
        wrapper.style.setProperty('--i', counter.i++);
        wrapper.appendChild(node.cloneNode(true));
        fragment.appendChild(wrapper);
    }

    function split(heading) {
        if (!heading || heading.dataset.fxSplit) { return; }
        heading.dataset.fxSplit = '1';

        var fragment = document.createDocumentFragment();
        var counter = { i: 0 };

        Array.prototype.slice.call(heading.childNodes).forEach(function (node) {
            splitInto(node, fragment, counter);
        });

        heading.textContent = '';
        heading.appendChild(fragment);
    }

    home.querySelectorAll('.h-xl').forEach(split);

    function lit() {
        home.classList.add('lit');
    }
    requestAnimationFrame(lit);
    setTimeout(lit, 60);

    document.querySelectorAll('.door').forEach(function (door) {
        door.addEventListener(
            'pointermove',
            function (event) {
                var rect = door.getBoundingClientRect();
                door.style.setProperty('--mx', event.clientX - rect.left + 'px');
                door.style.setProperty('--my', event.clientY - rect.top + 'px');
            },
            { passive: true }
        );
    });

    var blocks = [];
    [
        ['#mission .mistxt', 0],
        ['#mission .misstats', 1],
        ['#story .storytxt', 0],
        ['#story .storyquad', 1],
        ['.sechead--offer', 0],
        ['.techlead .stxt', 0],
        ['.techlead .picwrap', 1],
        ['.homedoors .doors', 0],
        ['#coverage .sechead', 0],
        ['#coverage .railwrap', 1],
        ['#funders .sechead', 0],
        ['#funders .fundgrid', 1] ].forEach(function (pair) {
        var el = document.querySelector(pair[0]);
        if (!el) { return; }
        el.setAttribute('data-fx', '');
        el.style.setProperty('--d', pair[1]);
        if (el.classList.contains('misstats')) {
            el.querySelectorAll('.bt').forEach(function (pill, n) {
                pill.style.setProperty('--i', n);
            });
        }
        blocks.push(el);
    });

    function reveal(el) {
        el.classList.add('seen');
    }

    if (window.IntersectionObserver) {
        var io = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) { return; }
                    reveal(entry.target);
                    io.unobserve(entry.target);
                });
            },
            { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
        );
        blocks.forEach(function (block) {
            io.observe(block);
        });
    }

    setTimeout(function () {
        blocks.forEach(reveal);
        home.classList.add('done');
    }, 2600);

    function canIgnite() {
        return window.__ooNet && window.__ooNet.ignite;
    }

    setTimeout(function () {
        if (canIgnite()) { window.__ooNet.ignite(0.66, 0.3); }
    }, 1200);
    setTimeout(function () {
        if (canIgnite()) { window.__ooNet.ignite(0.36, 0.46); }
    }, 1800);

    if (window.MutationObserver) {
        new MutationObserver(function () {
            if (canIgnite()) { window.__ooNet.ignite(0.15 + Math.random() * 0.7, 0.18 + Math.random() * 0.42); }
        }).observe(root, { attributes: true, attributeFilter: ['data-arm'] });
    }
}
